var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("统计管理")]),
            _c("el-breadcrumb-item", [_vm._v("统计分析")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "供应点分析", name: "supplyAnalysis" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.canvasLoading,
                            expression: "canvasLoading",
                          },
                        ],
                        staticClass: "canvas-box",
                        attrs: { id: "supplyAnalysis" },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "基地分析", name: "baseAnalysis" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.canvasLoading,
                            expression: "canvasLoading",
                          },
                        ],
                        staticClass: "canvas-box",
                        attrs: { id: "baseAnalysis" },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "畅销分析", name: "salesAnalysis" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.canvasLoading,
                            expression: "canvasLoading",
                          },
                        ],
                        staticClass: "canvas-box",
                        attrs: { id: "bestSales" },
                      }),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.canvasLoading,
                            expression: "canvasLoading",
                          },
                        ],
                        staticClass: "canvas-box",
                        attrs: { id: "worstSales" },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }